import { fundingHqFetch } from './fundingApi';

function agencyQuery(agencyId) {
  const params = new URLSearchParams({ agency_id: agencyId });
  return params.toString();
}

export async function createFundingDeal(clientId, agencyId, payload) {
  return fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/deals?${agencyQuery(agencyId)}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
}

export async function createDealFromSubmission(submissionId, agencyId) {
  return fundingHqFetch(`/submissions/${encodeURIComponent(submissionId)}/deal`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ agency_id: agencyId }),
  });
}

export async function fetchFundingDeals({
  agencyId,
  clientId,
  stage,
  lenderType,
  productType,
  assignedUserId,
  search,
  limit = 200,
} = {}) {
  const params = new URLSearchParams();
  if (agencyId) params.set('agency_id', agencyId);
  if (stage) params.set('stage', stage);
  if (lenderType) params.set('type', lenderType);
  if (productType) params.set('product_type', productType);
  if (assignedUserId) params.set('assigned_user_id', assignedUserId);
  if (search) params.set('search', search);
  if (limit) params.set('limit', String(limit));
  const query = params.toString();
  const data = await fundingHqFetch(`/deals${query ? `?${query}` : ''}`);
  return {
    deals: data.deals ?? [],
    total: data.total ?? (data.deals?.length ?? 0),
  };
}

export async function fetchClientFundingDeals(clientId, agencyId) {
  const data = await fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/deals?${agencyQuery(agencyId)}`,
  );
  return {
    deals: data.deals ?? [],
    total: data.total ?? (data.deals?.length ?? 0),
  };
}

export async function fetchFundingDeal(dealId, agencyId) {
  return fundingHqFetch(
    `/deals/${encodeURIComponent(dealId)}?${agencyQuery(agencyId)}`,
  );
}

export async function updateFundingDeal(dealId, agencyId, payload) {
  return fundingHqFetch(
    `/deals/${encodeURIComponent(dealId)}?${agencyQuery(agencyId)}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
}

export async function deleteFundingDeal(dealId, agencyId) {
  return fundingHqFetch(
    `/deals/${encodeURIComponent(dealId)}?${agencyQuery(agencyId)}`,
    { method: 'DELETE' },
  );
}

export function emptyFundingDealForm() {
  return {
    lender_id: '',
    lender_name: '',
    lender_type: '',
    product_type: 'Term Loan',
    requested_amount: '',
    approved_amount: '',
    funded_amount: '',
    stage: 'Prospect',
    probability: '',
    commission_type: 'Percentage',
    commission_rate: '3',
    close_date: '',
    clawback_risk: 'None',
    assigned_user_id: '',
    next_task: '',
    next_task_due_at: '',
    notes: '',
  };
}
